import { render } from "./BlueButton.vue?vue&type=template&id=9b0447e2"
import script from "./BlueButton.vue?vue&type=script&lang=js"
export * from "./BlueButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__